module.exports = __webpack_public_path__ + "sq10-6b9751f0.png";